import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useButtonGroupStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      [theme.breakpoints.up('sm')]: {
        '& button': {
          minWidth: '150px',
        },
      },
    },
    buttonSeparator: {
      width: '40px',
    },
  })
);
